
const usecheckIFrame = () => {
  return window.self !== window.top
}

export default usecheckIFrame;
